import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Stack,
  alpha,
  Divider,
} from '@mui/material';
import { getSamplePointRecord } from '../../../../helpers/api';
import { useEffect, useState } from 'react';
import LoaderSkeleton from '../../../common/LoaderSkeleton';
import { Empty } from 'antd';
import { parseString4 } from '../../../../helpers/utils';
import { openNotification } from '../../../../helpers/notification';
import { VisibilityOutlined, AnalyticsOutlined, TuneOutlined } from '@mui/icons-material';

export default function ResultViewMeasurementsParameterView({ report, samplePoint, onRefresh }) {
  const [samplePointParameter, setSamplePointParameter] = useState(null);
  const [samplePointParemeterLoading, setSamplePointParameterLoading] = useState(false);
  const [inputList, setInputList] = useState([]);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    if (samplePoint) fetchSamplePointParameters();
  }, [samplePoint]);

  useEffect(() => {
    if (refresh) fetchSamplePointParameters();
  }, [refresh]);

  const fetchSamplePointParameters = async () => {
    setSamplePointParameterLoading(true);
    try {
      const res = await getSamplePointRecord(samplePoint?.samplePointId, report?.reportId);
      const { data, status } = res?.result;
      if (status?.code === '00') {
        setSamplePointParameter(data);
        const flattenResultList = data?.results?.flatMap((i) => i.data) || [];
        let initInputList = [];

        data?.parameters?.forEach((i) => {
          const result = flattenResultList?.find((x) => x?.parameterId === i?.parameterId);
          const resultValue = !isNaN(result?.resultValue) ? result?.resultValue.toFixed(2) : '';
          initInputList.push({
            parameterId: i?.parameterId,
            unit: i?.unit,
            resultValue: resultValue,
          });
        });
        setInputList(initInputList);
      }
    } catch (error) {
      openNotification({ type: 'error', message: 'Failed to load parameter data' });
    } finally {
      setSamplePointParameterLoading(false);
      setRefresh(false);
    }
  };

  const renderReadView = () => (
    <Box>
      <TableContainer
        component={Box}
        sx={{
          borderRadius: '12px',
          border: '1px solid',
          borderColor: 'divider',
          overflow: 'hidden',
        }}
      >
        <Table size="small">
          <TableHead sx={{ bgcolor: alpha('#1976d2', 0.05) }}>
            <TableRow>
              {inputList?.map((header, idx) => (
                <TableCell
                  key={idx}
                  sx={{ borderRight: '1px solid', borderColor: 'divider', py: 1.5 }}
                >
                  <Typography
                    variant="caption"
                    fontWeight={700}
                    color="primary"
                    dangerouslySetInnerHTML={{ __html: header?.unit }}
                  />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              {inputList?.map((body) => {
                //const val = Number(body?.resultValue);
                //const displayVal = !isNaN(val) ? val.toFixed(2) : body?.resultValue;
                const displayVal = body?.resultValue === '' ? '' : Number(body?.resultValue);
                return (
                  <TableCell
                    key={body?.parameterId}
                    sx={{
                      borderRight: '1px solid',
                      borderColor: 'divider',
                      textAlign: 'right',
                      py: 2,
                    }}
                  >
                    <Typography variant="body2" fontWeight={700} color="text.primary">
                      {displayVal || ''}
                    </Typography>
                  </TableCell>
                );
              })}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );

  const handleContentRendering = () => {
    if (samplePointParemeterLoading) return <LoaderSkeleton />;
    if (!samplePointParameter) return <Empty description="No data available" />;
    return (
      <Box>
        <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 3 }}>
          <TuneOutlined color="primary" />
          <Box>
            <Typography variant="h6" fontWeight={700} sx={{ lineHeight: 1.2 }}>
              {samplePointParameter?.samplePointName}
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ textTransform: 'uppercase', fontWeight: 700, letterSpacing: 1 }}
            >
              {samplePointParameter?.groupName}
            </Typography>
          </Box>
        </Stack>
        <Divider sx={{ mb: 3 }} />
        {renderReadView()}
      </Box>
    );
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 4,
        borderRadius: '16px',
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: '#fff',
      }}
    >
      {handleContentRendering()}
    </Paper>
  );
}
